// ========== 主题状态管理 ==========
// 通过 Zustand + persist 持久化用户选择的主题

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { themes, DEFAULT_THEME_ID, ThemeConfig } from '@/themes';

interface ThemeState {
  themeId: string;
  theme: ThemeConfig;
  setTheme: (id: string) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => {
      const id = DEFAULT_THEME_ID;
      const theme = themes.find(t => t.id === id) || themes[0];
      return {
        themeId: id,
        theme,
        setTheme: (themeId: string) => {
          const t = themes.find(th => th.id === themeId);
          if (t) set({ themeId, theme: t });
        },
      };
    },
    {
      name: 'panda-oj-theme',
      partialize: (state) => ({ themeId: state.themeId }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          const theme = themes.find(t => t.id === state.themeId);
          if (theme) state.theme = theme;
        }
      },
    }
  )
);
